<template>
  <vs-tabs
    :position="isSmallerScreen ? 'top' : 'left'"
    class="tabs-shadow-none"
    id="profile-tabs"
    :key="isSmallerScreen"
  >
    <!-- GENERAL -->
    <vs-tab
      icon-pack="feather"
      icon="icon-user"
      :label="!isSmallerScreen ? 'Général' : ''"
    >
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <ProfileGeneral />
      </div>
    </vs-tab>
    <vs-tab
      icon-pack="feather"
      icon="icon-lock"
      :label="!isSmallerScreen ? 'Changer de mot de passe' : ''"
    >
      <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
        <ChangePass />
      </div>
    </vs-tab>
    <vs-tab
      icon-pack="feather"
      icon="icon-key"
      :label="!isSmallerScreen ? 'Intégration API' : ''"
    >
      <div class="tab-api md:ml-4 md:mt-0 mt-4 ml-0">
        <ApiIntegration />
      </div>
    </vs-tab>
  </vs-tabs>
</template>

<script>
import VueCookies from "vue-cookies";
import ProfileGeneral from "./ProfileGeneral.vue";
import ChangePass from "./ChangePass.vue";
import ApiIntegration from "./ApiIntegration.vue";

export default {
	name: "ProfileUserSettings",
	components: {
		ProfileGeneral,
		ChangePass,
		ApiIntegration
	},
	data() {
		return {
			apiUrl: this.$store.state.backendApiUrl,
			apiErrorMsg: null,
			user: null,
			name: this.$store.state.AppActiveUser.displayName
		};
	},
	created() {
		this.user = VueCookies.get("userInfo");
	},
	computed: {
		isSmallerScreen() {
			return this.$store.state.windowWidth < 768;
		}
	}
};
</script>
